import React, { useState, memo } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Menu, X, Coffee, MapPin, MessageSquare, Heart, ShoppingBag, Sunrise, PartyPopper, BookOpen, Bean, Store, Users } from 'lucide-react';
import { Link, useNavigate } from 'react-router-dom';
const menuItems = [{
  name: 'About Us',
  href: '/about',
  icon: Heart
}, {
  name: 'Menu',
  href: '/menu',
  icon: Coffee
}, {
  name: 'Roasters',
  href: '/roasters',
  icon: Bean
}, {
  name: 'Makers',
  href: '/makers',
  icon: Store
}, {
  name: 'Order Online',
  href: 'https://order.dripos.com/Grounded-Livermore',
  icon: ShoppingBag,
  highlight: true,
  external: true
}, {
  name: 'Community',
  href: '/community',
  icon: Users
}, {
  name: 'Location & Hours',
  href: '/location',
  icon: MapPin
}, {
  // Same Google Business Profile URL used by the footer's Google icon
  // in components/NewsletterSignup.tsx.
  name: 'Feedback',
  href: 'https://share.google/0d4dRWEqeCgdSEN99',
  icon: MessageSquare,
  external: true
}, {
  name: 'Catering',
  href: '/catering',
  icon: Sunrise
}, {
  name: 'Private Events',
  href: '/events',
  icon: PartyPopper
}, {
  name: 'Journal',
  href: '/journal',
  icon: BookOpen
}
// ARCHIVED: 'Memory Care Together' → /memory-care-together was listed here.
// Re-add this entry when the route is re-enabled in App.tsx.
];
export function HamburgerMenu() {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();
  const handleNavigation = (href: string, external?: boolean) => {
    setIsOpen(false);
    if (external) {
      window.open(href, '_blank', 'noopener,noreferrer');
    } else if (href.startsWith('/#')) {
      navigate('/');
      // In a real app, you'd handle scrolling to anchor here
    } else {
      navigate(href);
    }
  };
  return <>
      {/* Toggle Button */}
      <button onClick={() => setIsOpen(true)} className="fixed top-6 left-6 z-50 p-3 text-white mix-blend-difference hover:scale-110 transition-transform duration-200" aria-label="Open menu" data-id="element-26" data-mp="d6y66rl3e8uv">
        <Menu size={32} strokeWidth={1.5} data-id="element-27" data-mp="46t1ip7a9oke" />
      </button>

      {/* Full Screen Menu Overlay */}
      <AnimatePresence data-id="element-28" data-mp="3vdm7s7gxodvs">
        {isOpen && <motion.div initial={{
        x: '-100%'
      }} animate={{
        x: 0
      }} exit={{
        x: '-100%'
      }} transition={{
        type: 'spring',
        damping: 25,
        stiffness: 200
      }} className="fixed inset-0 z-50 bg-[#1a1a1a] text-white flex flex-col" data-id="element-29" data-mp="wup2i63vy2mz">
            {/* Header */}
            <div className="flex justify-between items-center p-6 border-b border-white/10" data-id="element-30" data-mp="1fmrcwzpxomos">
              <Link to="/" onClick={() => setIsOpen(false)} className="flex items-center gap-3" data-id="element-31" data-mp="1atojcrl5pd8l">
                <Coffee className="text-[#D97E3A]" size={28} data-id="element-32" data-mp="1n4fv9dbc3kkq" />
                <span className="font-bebas text-2xl tracking-wide" data-id="element-33" data-mp="1n6s85c28j4qx">
                  GROUNDED LIVERMORE
                </span>
              </Link>
              <button onClick={() => setIsOpen(false)} className="p-2 hover:text-[#D97E3A] transition-colors" aria-label="Close menu" data-id="element-34" data-mp="1x35b70jo6uyc">
                <X size={32} strokeWidth={1.5} data-id="element-35" data-mp="262s38vqieoeq" />
              </button>
            </div>

            {/* Menu Items */}
            <nav className="flex-1 flex flex-col justify-center px-8 md:px-16 space-y-6" data-id="element-36" data-mp="2avl7lii2fuqa">
              {menuItems.map((item, index) => <motion.button key={item.name} onClick={() => handleNavigation(item.href, item.external)} initial={{
            opacity: 0,
            x: -20
          }} animate={{
            opacity: 1,
            x: 0
          }} transition={{
            delay: index * 0.1 + 0.2
          }} className={`group flex items-center gap-4 text-4xl md:text-6xl font-bebas tracking-wide transition-colors text-left w-full ${item.highlight ? 'text-[#D97E3A]' : 'text-white hover:text-[#D97E3A]'}`} data-id="element-37" data-mp="2fv7j9ni8x2wz" data-mpi={index}>
                  <span className="opacity-0 group-hover:opacity-100 transition-opacity duration-300 -ml-8 md:-ml-12" data-id="element-38" data-mp="33lwpf1axs9lm">
                    <item.icon size={24} data-id="element-39" data-mp="3cki4gmh796hn" />
                  </span>
                  {item.name}
                </motion.button>)}
            </nav>

            {/* Footer Info */}
            <div className="p-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-start md:items-center gap-4 text-white/60 font-inter text-sm" data-id="element-40" data-mp="ruiy2hfsz5h5">
              <p data-id="element-41" data-mp="mv6fi8vyskkd">A neighborhood coffee shop, by neighborhood folks.</p>
              <div className="flex gap-6" data-id="element-42" data-mp="vbdsw2roaqkq">
                <a href="#" className="hover:text-white transition-colors" data-id="element-43" data-mp="vet7l4hfpxlm">
                  Instagram
                </a>
                <a href="#" className="hover:text-white transition-colors" data-id="element-44" data-mp="leivjn74yw81">
                  Facebook
                </a>
              </div>
            </div>
          </motion.div>}
      </AnimatePresence>
    </>;
}